/** @module Classes */ /** typedoc */
import { keys } from 'ts-transformer-keys/index';
import { InvoicePreviewMultiProducts } from './InvoicePreviewMultiProducts';
import { AbstractPreparePurchase } from './AbstractPreparePurchase';


export class ReleasePreparePurchase extends AbstractPreparePurchase {
    public invoicePreview: InvoicePreviewMultiProducts = null;
}

export const keysOfReleasePreparePurchase: Array<keyof ReleasePreparePurchase> = keys<ReleasePreparePurchase>();
